<template>
  <!-- 机油商品详情 -->
  <div class="oil-goods-detail">
    <div class="goods-imgs-swiper">
      <swiper ref="mySwiper" class="swiper" :options="swiperOption">
        <swiper-slide
          v-for="(item, index) in engine_oil_goods_info.swiper_medias"
          :key="index"
        >
          <div v-if="item.type === 'video'" class="item video-box">
            <video
              ref="goodsVideo"
              @ended="pauseVideo"
              :src="item.url"
              controls="controls"
            >
              您的浏览器不支持 video 标签。
            </video>
            <div v-if="videoOverlay" class="play-control" @click="videoPlay">
              <img
                src="https://select-oil-oss.vchangyi.com/wxapp/icon-play.png"
                alt=""
              />
            </div>
            <!-- <div class="mask" @click="pauseVideo"></div> -->
          </div>
          <div v-if="item.type === 'pic'" class="item">
            <img :src="item.url" />
          </div>
        </swiper-slide>
      </swiper>
      <div class="indicator">
        {{ activeIndex + 1 }}/{{
          engine_oil_goods_info.swiper_medias &&
          engine_oil_goods_info.swiper_medias.length
        }}
      </div>
    </div>
    <div class="basic-info">
      <!-- <div class="price-box" v-if="engine_oil_goods_info.price">
        <div class="price">
          <span class="unit">￥</span
          ><span class="price-text">{{
            engine_oil_goods_info.price / 100
          }}</span>
        </div>
        <div class="tag">建议零售价（{{ 4 }}L）</div>
      </div> -->
      <div class="goods-name">{{ engine_oil_goods_info.name }}</div>
      <div class="desc">{{ engine_oil_goods_info.describe }}</div>
    </div>
    <div class="goods-content">
      <div class="sub-title">商品详情</div>
      <div
        class="content-list"
        v-if="
          engine_oil_goods_info.info && engine_oil_goods_info.info.length > 0
        "
      >
        <img
          v-for="(item, index) in engine_oil_goods_info.info"
          :key="index"
          :src="item"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import api from "@/apis/maintenance-api.js";
import wx from "weixin-js-sdk";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      info: [],
      engine_oil_goods_info: {},
      activeIndex: 0,
      videoOverlay: true,
      swiperOption: {
        on: {
          slideChangeTransitionEnd: () => {
            let swiper = this.$refs.mySwiper.$swiper;
            this.activeIndex = swiper.activeIndex;
            this.$refs.goodsVideo[0].pause();
          },
        },
      },
    };
  },
  mounted() {
    if (this.browser.wx == 1) {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
    // 获取机油商品详情
    this.fetchEngineOilGoodsDetail();
  },
  methods: {
    // 获取机油商品详情
    async fetchEngineOilGoodsDetail() {
      this.$loading.show("加载中...");
      const params = { goods_id: Number(this.$route.query.goods_id) };
      try {
        const res = await api.getEngineOilGoodsDetailApi(params);
        this.$loading.hide();
        console.log(res, '----fetchEngineOilGoodsDetail')
        if (res.code === 0) {
          this.engine_oil_goods_info = res.data;
          this.engine_oil_goods_info.swiper_medias =
            res.data.video_url && res.data.video_status === 2
              ? [
                  { url: res.data.video_url, type: "video" },
                  { url: res.data.url, type: "pic" },
                ]
              : [{ url: res.data.url, type: "pic" }];
        } else {
          this.$toast.show({
            showTime: 3,
            message: "获取商品详情失败",
            style: "error",
          });
        }
      } catch (err) {
        this.$loading.hide();
        console.log("获取商品详情失败！", err);
      }
    },
    videoPlay() {
      if (this.$refs.goodsVideo[0].paused) {
        this.$refs.goodsVideo[0].play();
        this.videoOverlay = false;
      } else {
        this.$refs.goodsVideo[0].pause();
        this.videoOverlay = true;
      }
    },
    pauseVideo() {
      this.$refs.goodsVideo[0].pause();
      this.videoOverlay = true;
    },
  },
};
</script>

<style lang="less" scoped>
.oil-goods-detail {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .goods-imgs-swiper {
    width: 100%;
    height: 640/100rem;
    position: relative;
    .item {
      width: 640/100rem;
      height: 640/100rem;
      img {
        width: 100%;
        height: 100%;
      }
      video {
        width: 100%;
        height: 100%;
      }
    }
    .video-box {
      width: 640/100rem;
      height: 640/100rem;
      position: relative;
      .play-control {
        position: absolute;
        z-index: 22;
        top: 0;
        left: 0;
        width: 640/100rem;
        height: 640/100rem;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 79/100rem;
          height: 79/100rem;
        }
      }
      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 85%;
        // background: skyblue;
      }
    }
    .indicator {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      z-index: 19;
      top: 29/100rem;
      right: 27/100rem;
      width: 55/100rem;
      height: 34/100rem;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 20/100rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 29/100rem;
      font-size: 20/100rem;
    }
  }
  .basic-info {
    padding: 20/100rem 26/100rem 53/100rem 26/100rem;
    padding-top: 12/100rem;
    .price-box {
      display: flex;
      align-items: center;
      .price {
        .unit {
          font-weight: 500;
          color: #ce4747;
          line-height: 34/100rem;
          font-size: 24/100rem;
        }
        .price-text {
          font-weight: 500;
          color: #ce4747;
          line-height: 56/100rem;
          font-size: 41/100rem;
        }
      }
      .tag {
        margin-left: 14/100rem;
        display: inline-block;
        text-indent: 5px;
        height: 34/100rem;
        line-height: 33/100rem;
        color: #ce4747;
        font-size: 19/100rem;
        background: rgba(206, 71, 71, 0.2);
        border-radius: 7/100rem;
        border: 2/100rem solid rgba(206, 71, 71, 0.36);
      }
    }

    .goods-name {
      // margin-top: 15/100rem;
      margin-bottom: 17/100rem;
      font-weight: 500;
      color: #333333;
      // line-height: 38/100rem;
      font-size: 27/100rem;
    }
    .desc {
      color: #666666;
      line-height: 34/100rem;
      font-size: 24/100rem;
    }
  }
  .goods-content {
    display: flex;
    flex-direction: column;
    .sub-title {
      padding-left: 27/100rem;
      padding-top: 27/100rem;
      padding-bottom: 29/100rem;
    }
    .content-list {
      display: flex;
      flex-direction: column;
      margin-bottom: 100/100rem;
      img {
        max-width: 100%;
      }
    }
  }
}
</style>
